export default function firestoreGetDoc({ getDoc, doc, getFirestore }, path) {
  if (typeof getDoc === "function") {
    // Client SDK
    return getDoc(doc(getFirestore(), path));
  } else {
    // Admin SDK
    return getFirestore().doc(path).get();
  }
}
